import React from 'react'
import { Form, Field, FormikProps } from 'formik'
import { StyledFormActionWrapper } from '../../layouts'
import {
  Button,
  H2,
  CustomTextField,
  DateAuthorFragment,
} from '../../components'
import { IMediaTypeGroup } from '../../types/mediaTypeGroup'

interface IMediaTypeGroupForm {
  cancelAction?: () => void
  editable?: boolean
  submitText: string
  formikProps: FormikProps<IMediaTypeGroup>
}

export const MediaTypeGroupForm = ({
  submitText,
  cancelAction,
  editable = true,
  formikProps,
}: IMediaTypeGroupForm) => (
  <>
    <H2 mb={4}>Enter metadata and save</H2>
    <Form>
      <Field
        name="title"
        label="Title"
        component={CustomTextField}
        disabled={!editable}
      />
      <Field
        name="description"
        label="Description"
        component={CustomTextField}
        disabled={!editable}
      />
      <DateAuthorFragment {...formikProps.values} />
      <StyledFormActionWrapper>
        {!!cancelAction && (
          <Button id="cancel-button" onClick={cancelAction}>
            Cancel
          </Button>
        )}
        <Button
          id="submit-form-data"
          type="submit"
          variant="contained"
          color="primary"
          disabled={!formikProps.isValid || !editable}
        >
          {submitText}
        </Button>
      </StyledFormActionWrapper>
    </Form>
  </>
)
